import React from 'react';
import styled from 'styled-components';

const MandatoryLinks = ({ Domain }) => {
  const today = new Date();
  return (
    <>
      <Banner>
        To learn more about how we collect, use, disclose, transfer, and store your information, and
        other use policies, please read our{' '}
        <a
          href={`https://${window.location.host}/account/privacy-policy`}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>{' '}
        and &nbsp;
        <a href={`https://${window.location.host}/account/terms`} target="_blank" rel="noreferrer">
          Terms of Use
        </a>
      </Banner>
      <LinkContainer>
        <p>Copyright © {today.getFullYear()} nuwaveco.com</p>
      </LinkContainer>
    </>
  );
};

export default MandatoryLinks;

const Banner = styled.div`
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
  @media (max-height: 1000px) {
    padding-top: 50px;
  }
`;

const LinkContainer = styled.div`
  font-size: 12px;
  font-weight: 400;
  width: 100%;
  max-width: 600px;
  height: 100%;
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 768px) {
    width: 100%;
    padding: 20px 20px 0 20px;
  }

  @media (max-height: 1000px) {
    padding-top: 10px;
  }
`;
